import React, { FC } from 'react';
import styles from './roomstay-blog-customer-case-list-card-3.module.scss';

import classNames from 'classnames';
import ClippedBox from '../roomstay-blog-image-block/clipped-box';
import { useElementSize, useWindowSize } from 'usehooks-ts';
import { LazyLoadImage } from '../lazy-load-image';
import ButtonBookADemo from '../ButtonBookADemo';

export interface CustomerCaseListCard3Props {
    tag?: string;
    title?: string;
    description?: string;

    ctaButton?: {
        text?: string;
        href?: string;
    };

    cards?: {
        background?: string;
        icon?: string;
        contentData?: string;
        title?: string;
        description?: string;
    }[];
}

const RoomStayBlogCustomerCaseListCard3: FC<CustomerCaseListCard3Props> = (props) => {
    const { tag, title, description, cards, ctaButton } = props;
    const [containerRef] = useElementSize();
    const { width: windowWidth } = useWindowSize();
    const isMobile = windowWidth <= 768;

    return (
        <div ref={containerRef} className={styles.container}>
            <div className={styles.backgroundColor}></div>
            <div className={styles.wrapperBox}>
                <div className={styles.boxLeft}>
                    <div className={styles.tag} dangerouslySetInnerHTML={{ __html: tag || '' }}></div>
                    <h2 className={styles.title} dangerouslySetInnerHTML={{ __html: title || '' }}></h2>
                    <div className={styles.description} dangerouslySetInnerHTML={{ __html: description || '' }}></div>
                    {ctaButton?.text && (
                        <ButtonBookADemo className={styles.button} icon={false} iconFillColor={false} type="highty" size="default" htmlType="button" sectionId={ctaButton?.href}>
                            {ctaButton?.text || 'Book a Demo'}
                        </ButtonBookADemo>
                    )}
                </div>

                <div className={styles.boxRight}>
                    {cards?.map((card, cardIndex) => {
                        return (
                            <div key={cardIndex} className={styles.itemWrapper}>
                                <div className={classNames(styles.item)} style={{ backgroundColor: `${card.background}` }}>
                                    <div className={styles.leftBlock}>
                                        {card.icon && (
                                            <div className={styles.icon}>
                                                <LazyLoadImage className={styles.wrapperImg} imageUrl={card.icon} objectFit="cover" />
                                            </div>
                                        )}
                                        {card.contentData && (
                                            <div className={styles.contentData} dangerouslySetInnerHTML={{ __html: card.contentData || '' }}></div>
                                        )}
                                    </div>
                                    <div className={styles.rightBlock}>
                                        <h3 className={styles.title} dangerouslySetInnerHTML={{ __html: card.title || '' }}></h3>
                                        <div className={styles.description} dangerouslySetInnerHTML={{ __html: card.description || '' }}></div>
                                    </div>
                                </div>
                            </div>
                        );
                    })}
                </div>
            </div>
        </div>
    );
};

export default RoomStayBlogCustomerCaseListCard3;
